import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {},
  media: {
    height: "250px",
    width: "100%",
    position: "relative",
    borderRadius: "4px",
    backgroundSize: "cover",
    [theme.breakpoints.down("md")]: {
      height: "298px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "200px",
    },
    [theme.breakpoints.down("xs")]: {
      height: "298px",
    },
  },
  itemCard: {
    padding: "15px",
    position: "relative",
    borderRadius: "4px",
    height: "250px",
    [theme.breakpoints.down("md")]: {
      height: "299px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "200px",
    },
    [theme.breakpoints.down("xs")]: {
      height: "299px",
    },
  },
  overlay: {
    backgroundColor: "rgba(0,0,0, 0.4)",
    color: "#ffff",
    position: "absolute",
    zIndex: "0",
    bottom: "15px",
    top: "15px",
    left: "15px",
    right: "15px",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    height: "250px",
    [theme.breakpoints.down("md")]: {
      height: "298px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "200px",
    },
    [theme.breakpoints.down("xs")]: {
      height: "298px",
    },
    "&:hover": {
      zIndex: "0",
    },
  },
  numberWrapMain: {
    color: "#ffff",
    position: "relative",
    zIndex: 1,
    left: 10,
    textAlign: "center",
    display: "flex",
    justifyContent: "space-between",
    alignContent: "center",
    alignItems: "center",
    bottom: "313px",
    [theme.breakpoints.down("md")]: {
      bottom: "317px",
    },
    [theme.breakpoints.down("sm")]: {
      bottom: "230px",
    },
    [theme.breakpoints.down("xs")]: {
      bottom: "328px",
    },
    "&:hover": {
      zIndex: "1",
    },
  },
  numberWrap: {
    width: "40px",
    height: "25px",
    backgroundColor: "rgba(255,255,255, 0.7)",
    borderRadius: "10px",
    marginLeft: "10px",
    marginTop: "265px",
    zIndex: "1",
    [theme.breakpoints.down("sm")]: {
      marginTop: "185px",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "265px",
    },
  },
  numberText: {
    height: "22px",
    borderRadius: "10px",
    fontFamily: "Gilroy-Light, serif",
    textTransform: "capitalize",
    fontSize: "12px",
    fontWeight: 400,
    color: "#000",
    marginTop: 4,
    textAlign: "center",
  },
  mainText: {
    fontFamily: "Gilroy-ExtraBold, serif",
    textTransform: "capitalize",
    color: "#fff",
    fontSize: "1.2rem",
  },
  viewWrap: {
    position: "relative",
    zIndex: "4",
    bottom: "535px",
    textAlign: "right",
    paddingRight: "15px",
    [theme.breakpoints.down("md")]: {
      bottom: "576px",
    },
    [theme.breakpoints.down("sm")]: {
      bottom: "412px",
    },
    [theme.breakpoints.down("xs")]: {
      bottom: "576px",
    },
  },
  view: {
    color: "#fff",
    fontFamily: "Gilroy-Light, serif",
    textTransform: "capitalize",
    fontSize: "1rem",
  },
}));
